module.exports = __webpack_public_path__ + "fonts/Quicksand-500-latin9.7b81366.woff2";